import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { Container as ContainerBase } from "components/misc/Layouts.js";
import logo from "../../images/logo.svg";
import { ReactComponent as FacebookIcon } from "../../images/facebook-icon.svg";
import { ReactComponent as TwitterIcon } from "../../images/twitter-icon.svg";
import { ReactComponent as YoutubeIcon } from "../../images/youtube-icon.svg";
import { Link } from "react-router-dom";

const Container = tw(ContainerBase)`bg-gray-900 text-gray-100 -mx-8 -mb-8`;
const Content = tw.div`max-w-screen-xl mx-auto py-20`;

const Row = tw.div`flex items-center justify-center flex-col px-8`;

const LogoContainer = tw.div`flex items-center justify-center md:justify-start`;
const LogoImg = tw.img`w-8`;
const LogoText = tw.h5`ml-2 text-2xl font-black tracking-wider`;

const LinksContainer = tw.div`mt-8 font-medium flex flex-wrap justify-center items-center flex-col sm:flex-row`;
const Links = tw.a`border-b-2 border-transparent hocus:text-gray-300 hocus:border-gray-300 pb-1 transition duration-300 mt-2 mx-4`;

const SocialLinksContainer = tw.div`mt-10`;
const SocialLink = styled.a`
  ${tw`cursor-pointer inline-block text-gray-100 hover:text-gray-500 transition duration-300 mx-4`}
  svg {
    ${tw`w-5 h-5`}
  }
`;

const CopyrightText = tw.p`text-center mt-10 font-medium tracking-wide text-sm text-gray-600`;
export default () => {
  return (
    <Container>
      <Content>
        <Row>
          <LogoContainer>
            <LogoText>Yakshagana Puppets</LogoText>
          </LogoContainer>
          <LinksContainer>
            <Link to="/" onClick={() => window.scrollTo(0, 0)}>
              <Links>Home</Links>
            </Link>
            <Link to="/family-background" onClick={() => window.scrollTo(0, 0)}>
              <Links>About</Links>
            </Link>
            <Link
              to="/puppets-yakshagana-string-puppets"
              onClick={() => window.scrollTo(0, 0)}
            >
              <Links>Puppets</Links>
            </Link>
            <Link to="/gallery-awards" onClick={() => window.scrollTo(0, 0)}>
              <Links>Gallery</Links>
            </Link>
            <Link to="/contact-us" onClick={() => window.scrollTo(0, 0)}>
              <Links>Contact Us</Links>
            </Link>
          </LinksContainer>
          <SocialLinksContainer>
            <SocialLink href="https://www.facebook.com/bhaskar.koggakamath">
              <FacebookIcon />
            </SocialLink>
            <SocialLink href="https://twitter.com/kamathbhaskar?s=09">
              <TwitterIcon />
            </SocialLink>
            <SocialLink href="https://www.youtube.com/channel/UCYCfI1Cwjw3lAKtK8QhzkQg">
              <YoutubeIcon />
            </SocialLink>
          </SocialLinksContainer>
          <CopyrightText>
            &copy; Copyright 2020, Yakshagana Puppets Inc. All Rights Reserved.
          </CopyrightText>
        </Row>
      </Content>
    </Container>
  );
};
